module.exports = __webpack_public_path__ + "static/img/sc10.d794bb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc10.png
// module id = 1eJW
// module chunks = 25